import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-255a6ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute bottom-0 flex left-0 top-0" }

import useDivider from '@/shared/navigation/site-navigation/useDivider';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedDivider',
  setup(__props) {

const { targetHeight } = useDivider();

const maxHeight = computed<Object>(() => {
    return { 'max-height': `${targetHeight.value}px` };
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", {
      class: "divider",
      "aria-hidden": "true",
      style: _normalizeStyle(_unref(maxHeight))
    }, null, 4)
  ]))
}
}

})